import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchNotifs } from "Thunks";

import NotifsComponent from "./NotifsComponent";

class NotifsContainer extends Component {
  componentDidMount() {
    const { fetchNotifs, navCommunity } = this.props;
    if (navCommunity) {
      fetchNotifs({ limit: 5 });
    }
  }

  render() {
    return <NotifsComponent {...this.props} />;
  }
}
// Connected Component
const mapStateToProps = state => ({
  notifs: state.notifs.items,
  fetched: state.notifs.fetched,
  lng: state.params.lng,
  navCommunity: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({
  fetchNotifs: options => dispatch(fetchNotifs(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotifsContainer);



// WEBPACK FOOTER //
// ./src/components/Menu/Notifs/NotifsContainer.js